// The file the application imports. The build swaps it for another depending
// on the configuration, through `fileReplacements` on the build target in
// angular.json -- that is where to look to find out which file a given
// configuration gets. Tests have no replacement, so they run against this one.
//
// Everything here is compiled into the bundle and served to the browser. The
// Auth0 client id and the measurement id are public identifiers, which is why
// they can live here. Secrets cannot.

export const environment = {
  production: false,
  apiBaseUrl: 'https://report-api-dot-power-pro-dev.appspot.com/api',
  auth: {
    clientId: 'nXdtoEWpJVPXb8SLk1WiElwjCIdIIppe',
    domain: 'powerpro-dev.auth0.com',
    audience: 'https://horizon-api-dot-power-pro-dev.appspot.com/',
  },
  metrics: {
    google: {
      measurementId: 'G-2T7QMSWWZ2',
    },
  },
};
